<template>
    <div>
        <label :for="id"
               class="block text-sm font-medium leading-5 text-gray-700"
               v-html="label"
               v-if="label"
        ></label>
        <div class="mt-1 relative rounded-md shadow-sm">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" v-if="$slots.default">
                <slot></slot>
            </div>
            <input :type="type"
                   :id="id"
                   :name="name"
                   class="form-input block w-full sm:text-sm sm:leading-5"
                   :class="{
                       'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red pr-10': error,
                       'pl-6': $slots.default,
                       'text-gray-500 focus:border-gray-300 focus:shadow-none': readOnly
                   }"
                   :placeholder="placeholder"
                   :value="value"
                   :required="required"
                   :step="step"
                   :readonly="readOnly"
                   @input="$emit('input', $event.target.value)"
                   @keydown.enter="$emit('enter', $event)"
            />

            <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                 v-if="error || $slots.addOn"
            >
                <svg class="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20" v-if="error">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>

                <span class="text-gray-500 sm:text-sm sm:leading-5" v-if="$slots.addOn && ! error">
                    <slot name="addOn"></slot>
                </span>
            </div>
        </div>
        <p class="mt-1 text-xs text-gray-400" v-if="! error">
            {{ description }}
        </p>
        <p class="mt-1 text-xs text-red-600">
            {{ error }}
        </p>
    </div>
</template>

<script>
	export default {
		props: {
		    type: {
		        type: String,
                default: 'text',
            },

		    label: {
		        type: String,
            },

            id: {
		        type: String,
            },

            name: {
		        type: String,
            },

            error: {
		        type: String,
            },

            placeholder: {
		        type: String,
            },

            required: {
		        type: Boolean,
                default: false
            },

            step: {
		        type: String,
            },

            description: {
		        type: String,
            },

            value: {
		        required: true,
            },

            readOnly: {
		        type: Boolean,
                default: false
            }
        }
	}
</script>
